import React, { useEffect } from 'react';

import {
  fetchCurrentUser,
  selectAuthStatus,
} from '@/shared/redux/api/auth/auth-api';
import { useAppDispatch, useAppSelector } from '@/shared/redux/hooks/hooks';
import { LoadingStateEnum } from '@/shared/types/common.types';

type AuthLoaderProps = {
  renderLoading: () => React.ReactElement;
  renderUnauthenticated?: () => React.ReactElement;
  children: React.ReactNode;
};

export const AuthLoader: React.FC<AuthLoaderProps> = ({
  renderLoading,
  children,
}) => {
  const authStatus = useAppSelector(selectAuthStatus);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchCurrentUser());
  }, []);

  if (
    authStatus === LoadingStateEnum.IDLE ||
    authStatus === LoadingStateEnum.LOADING
  ) {
    return renderLoading();
  }

  return <>{children}</>;
};
